import PropTypes from 'prop-types'

const DoubleToggleButton = ({ options, onChange, selectedUuid }) => {
  return (
    <div className="double-toggle-button">
      {options?.map(({ label, uuid }) => {
        return (
          <button
            type="button"
            key={uuid}
            className={`double-toggle-button__button ${
              uuid === selectedUuid ? '-active' : ''
            }`}
            onClick={() => onChange(uuid)}
          >
            {label}
          </button>
        )
      })}
    </div>
  )
}

DoubleToggleButton.propTypes = {
  options: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      uuid: PropTypes.string,
    })
  ).isRequired,
  onChange: PropTypes.func,
  selectedUuid: PropTypes.string,
}

export default DoubleToggleButton
